import React from "react";

export default class PackageAddons extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      addons: []
    };
  }

  addonAction(addon,index){
    this.props.onSelectingAddons(addon)
    var addons = this.props.addons
    addons[index].selected = !addons[index].selected
  }

  setAddons(){
    var addons = this.props.addons
    var selectedAddons = this.props.selectedAddons
    for(var i=0; i < addons.length; i++){
      addons[i].selected = false
    }
    for(var index=0; index < addons.length; index++){
      for(var selectedIndex = 0; selectedIndex < selectedAddons.length; selectedIndex++){
        if(addons[index].name === selectedAddons[selectedIndex]){
          addons[index].selected = true
        }
      }
    }
    this.setState({
      addons: addons
    })
  }

  componentDidMount() {
    this.setAddons()
  }

  componentDidUpdate(prevProps){
    if (
      prevProps.addons !== this.props.addons ||
      prevProps.selectedAddons !== this.props.selectedAddons
    ) {
      this.setAddons()
    }
  }

  getStateValue(){
    var selectedGeography = this.props.selectedGeography

    if (selectedGeography.national) {
      return "national"
    } else {
      if (selectedGeography.states && selectedGeography.states.length > 1) {
         return "two_state"
      } else {
        return "one_state"
      }
    }
  }

  render(props){
    var addonsList = this.state.addons.map(function (addon, index) {
      let classNames = require('classnames');
      var addonTileClass = classNames({
        'alert pointer': !addon.selected,
        'alert alert-success pointer': addon.selected
      });
      var addonValueClass = classNames({
        'col-sm-3 text-right grey-text':!addon.selected,
        'col-sm-3 text-right success-text':addon.selected
      });

      return(
        <div className={addonTileClass} key={index} onClick={()=>{this.addonAction(addon, index)}}>
          <div className="row">
            <div className="col-sm-9">
              <div className="row no-margin addons-header body">
                {addon.name}
                {
                  addon.sticker === true &&
                  <span className="new-inline-tag"><i className="fa fa-star" aria-hidden="true"></i>
                    <span> New</span>
                  </span>
                }
              </div>

              <div className="row no-margin footnote-text">
                {addon.description}
              </div>
            </div>
            <div className={addonValueClass}>
              {
                addon.base_price &&
                <span>
                  +${addon.base_price[this.getStateValue()]}
                </span>
              }
              {
                !addon.base_price &&
                <span>
                  +${addon.price.toFixed(2)}
                </span>
              }
            </div>
          </div>
        </div>
      )
    },this)
    return(
      <div className="panel-body-spacing">
        {addonsList}
      </div>
    )
  }
}
